let basePath = process.env.API_URL
let baseAPIGroup = 'admin/'
let APIVersion = 'v1/'

export default {
  basePath: basePath,
  baseAPIGroup: baseAPIGroup,
  APIVersion: APIVersion,
  fullAPIPath: basePath + baseAPIGroup + APIVersion
}



// WEBPACK FOOTER //
// ./src/config.js